import * as React from 'react';
import * as firebase from 'firebase';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { Elements, StripeProvider } from 'react-stripe-elements';
import StripeCheckoutForm from './StripeCheckoutForm';
import { BookingData, HotelBedData } from '../shared/index';
import { FormatterUtils, STRIPEKEY } from '../core/Const';
import { momentWrapper, getAjaxhelper, momentDuration } from '../utils/index';
import { History } from 'history';
export interface BookingCheckoutProps extends BaseComponentProps {
    uuid: string;
    // sendStripeToken: (id: string, email: string, wallet: number) => any;
    lang: string;
    firebaseApp: firebase.app.App;
    checkoutId: number;
    history: History;
}

export interface BookingCheckoutState extends BaseComponentState {
    bookingCheckoutData: BookingData.BookingCheckOut;
    requesting: boolean;
    stripeToken: string;
    checkoutEmail: string;
}

export class BookingCheckout extends BaseComponent<BookingCheckoutProps, BookingCheckoutState> {

    constructor(props: BookingCheckoutProps) {
        super(props);
        this.state = {
            bookingCheckoutData: {},
            requesting: true,
            stripeToken: '',
            checkoutEmail: ''
        };
    }

    /*
    getWallet = () => {
        getAjaxhelper().post("/dynamics/bham-api/get-my-wallet", {
            cur: this.state.bookingCheckoutData.currencyCode
        }).then(
            (data: any) => {
                let wallet = data.amount || 0;
                this.props.firebaseApp.database().ref(`userData/${this.props.uuid}/bookingData/${this.props.responKey}`).on( 
                    'value', 
                    snapshot => {
                        if (!snapshot) {
                            // console.error(`${prfx} dari firebase, path : ${path} melaporkan null. tidak di proses`) ; 
                            return;
                        }
                        let isiStorage = snapshot.val();
                        let checkoutData: BookingData.HotelBookCheckoutData = JSON.parse(isiStorage!.checkoutData);
                        checkoutData.walletAmmount = wallet;
                        isiStorage!.checkoutData = JSON.stringify(checkoutData);
                        let requesting = false;
                        let total = checkoutData.totalAmount;
                        let discValue = checkoutData.discountAmount ? checkoutData.discountAmount : 0 ;
                        let totalDue = total; // checkoutData.totalAmount - checkoutData.discountAmount!;
                        if (totalDue <= 0) {
                            totalDue = 0;
                        } else if (wallet > 0) {
                            totalDue -= wallet;
                        }
                        if (totalDue < 0) {
                            totalDue = 0;
                        }
                        this.setState({ isiStorage, requesting, wallet, total, totalDue: total, discValue });
                    }
                );

            }).catch(exc => {
                console.log(exc);
            });
    }
*/
    getData = () => {
        getAjaxhelper().post("/dynamics/hb-api/checkout-booking-data-collection", {
            id: this.props.checkoutId,
            lang: this.props.lang
        }).then(
            (data: any) => {
                this.setStateHelper(
                    st => {
                        st.requesting = false;
                        st.bookingCheckoutData = data;
                    }
                );
            }).catch(exc => {
                console.log(exc);
            });
    }
    componentDidMount() {
        this.getData();
    }

    stripeSend = (token: string, email: string) => {
        // this.props.sendStripeToken(token , email , this.state.wallet) ;
        console.log("stripeSend", token, email);
        this.setStateHelper(
            st => {
                st.stripeToken = token;
                st.checkoutEmail = email;
            },
            () => {
                this.checkOutProcess(email, token, this.props.history);
            }
        );
    }
    /**
     * checker set timeout
     */
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let returnPanel = <span />;
        if (this.state.requesting === false) {
            let isiStorage = this.state.bookingCheckoutData!;
            let checkoutData: BookingData.BookingCheckOut = isiStorage;
            let rateData: { roomName: string, rateKey: string, boardName: string; paxes: { name: string, surname: string, type: 'AD' | 'CH' }[], rate: HotelBedData.Rate }[] = JSON.parse(isiStorage.rooms!);
            let hotelData: HotelBedData.Hotel = checkoutData.Hotel!;
            let tanggal = momentWrapper(checkoutData.checkOut!);
            let today = momentWrapper(checkoutData.checkIn!);
            let totalNight: number = momentDuration(tanggal.diff(today)).as('day');
            let haveCupon = isiStorage.haveCupon!;
            let cuponCode: string = isiStorage.cuponCode!;
            let cuponDisc = isiStorage.discountAmount;
            let holder = JSON.parse(isiStorage.holder!);
            let isiTbody = [];
            let total = isiStorage.totalAmount;
            let newTotal = isiStorage.totalAmount! - isiStorage.discountAmount!;
            let curencyCode = checkoutData.currencyCode;
            for (let room of rateData) {
                isiTbody.push(
                    <tr>
                        <td> <h5>{room.roomName}</h5>  </td>
                        <td> {totalNight} </td>
                        <td> {room.boardName}  </td>
                        <td> {room.rate.rooms}<i className='fa fa-bed' /> {room.rate.adults}<i className="fa fa-user" /> {room.rate.children}<i className="fa fa-child" /> {room.rate.children !== 0 ? '(' + room.rate.childrenAges + ')' : ''} </td>
                        <td> {curencyCode} {room.rate.net}</td>
                    </tr>
                );
            }
            let isifoot = [];

            if (haveCupon === "true") {
                isifoot.push(
                    <tr>
                        <td colSpan={4} > <h5> Sub Total  </h5>  </td>
                        <td> {new FormatterUtils().formatMoney((total!), curencyCode!, true, false)} </td>
                    </tr>
                );
                isifoot.push(
                    <tr>
                        <td colSpan={4} > <h5> Discount using Coupon Code {cuponCode} {(cuponDisc! / total! * 100).toFixed(0)}% </h5>  </td>
                        <td> {new FormatterUtils().formatMoney((cuponDisc!), curencyCode!, true, false)} </td>
                    </tr>
                );
            }
            isifoot.push(
                <tr>
                    <td colSpan={4} > <h5> Total Due </h5>  </td>
                    <td> {new FormatterUtils().formatMoney((newTotal), curencyCode!, true, false)} </td>
                </tr>
            );
            let paymentOption = <span />;
            let pesanOneDolar = <span />;
            if (isiStorage.oneDolarDeposit === 'TRUE') {
                pesanOneDolar = (
                    <div className="alert alert-success" style={{marginBottom: 0}}> 
                        $1 Holiday Deposit Sale – Book Your Room Today For $1 Deposit – Pay 2 Weeks Before You Arrive
                    </div>
                );
            }
            if (newTotal > 0) {
                paymentOption = (
                    <div className="invoice panel panel-white">
                        <div className="panel-heading">
                            <h4 className="panel-title">Payment Option</h4>
                        </div> 
                        <div className="panel-body row"> 
                            <div className="col-md-12">
                            {pesanOneDolar}
                                <StripeProvider apiKey={`${STRIPEKEY}`} >
                                    <div className="example">
                                        <Elements>
                                            <StripeCheckoutForm
                                                email={holder.email}
                                                sendStripeToken={this.stripeSend}
                                                stripe={StripeProvider}
                                            />
                                        </Elements>
                                    </div>
                                </StripeProvider>
                            </div>
                        </div>
                    </div>
                );
            } else {
                paymentOption = (
                    <div className="invoice panel panel-white">
                        <div className="panel-body row">
                            <div className="col-md-12">
                                <button >Book now</button>
                            </div>
                        </div>
                    </div>
                );
            }

            returnPanel = (
                <div className='container' style={{ paddingTop: 140 }}>
                    <div className="invoice panel panel-white">
                        <div className="panel-body row">
                            <div className="col-md-12">
                                <div className="col-md-4">
                                    <img src="/assets/images/calender.png" style={{ float: 'left', marginTop: 5 }} />
                                    <div style={{ margin: "5px 0px 0px 80px" }}>Check In <br />
                                        <h3 style={{ fontWeight: 500, color: "rgb(3, 174, 239)" }}>{momentWrapper(checkoutData.checkIn!).format('MMMM Do YYYY')}</h3>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <img src="/assets/images/calender.png" style={{ float: 'left', marginTop: 5 }} />
                                    <div style={{ margin: "5px 0px 0px 80px" }}>
                                        Check Out  <br />
                                        <h3 style={{ fontWeight: 500, color: "rgb(3, 174, 239)" }}>{momentWrapper(checkoutData.checkOut!).format('MMMM Do YYYY')}</h3>
                                    </div>
                                </div>
                                <div className="col-md-4  ">
                                    <img src="/assets/images/info.png" style={{ float: 'left', marginTop: 5 }} />
                                    <div style={{ margin: "5px 0px 0px 80px" }}>
                                        <span style={{ background: "rgb(3, 174, 239)", fontSize: 24, color: "rgb(255, 255, 255)", padding: "4px 20px", borderRadius: 10 }}> CHECKOUT  </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="invoice panel panel-white">
                        <div className="panel-body row">
                            <div className="col-md-12">
                                <h4>Booking Holder </h4>
                                <div className="form-group row">
                                    <label className="col-sm-2 control-label">
                                        Name
                                </label>
                                    <div className="col-sm-10">
                                        : {holder.name} {holder.surname}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 control-label">
                                        Address
                                </label>
                                    <div className="col-sm-10">
                                        : {holder.address}, {holder.city},  {holder.country},  {holder.postalCode}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 control-label">
                                        Contact
                                </label>
                                    <div className="col-sm-10">
                                        : E.  {holder.email}, P.  {holder.phone}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="invoice panel panel-white">
                        <div className="panel-body row">
                            <div className="col-md-12">
                                <h3>{hotelData.name}</h3>
                                <p>{hotelData.address}</p>
                                <p>E. {hotelData.email}</p>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Room Type</th>
                                            <th>Number of Night/s</th>
                                            <th>Board</th>
                                            <th>Detail</th>
                                            <th>Net</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isiTbody}
                                    </tbody>
                                    <tfoot>
                                        {isifoot}
                                    </tfoot>
                                </table>
                                <p>{hotelData.description}</p>
                            </div>
                        </div>
                    </div>
                    {paymentOption}
                </div>
            );
        }

        return (
            <div> {returnPanel} </div>
        );
    }

    checkOutProcess =  ( stripeEmail: string, stripeToken: string, history: History) => { 
        getAjaxhelper().post("/dynamics/booking-api/bookingprocess", {checkoutId: this.props.checkoutId, stripeKey: stripeToken, stripeEmail: stripeEmail }).then(
            (d: BookingData.BookingCheckOut) => {
                history.push(`/booking-progress?id=${d.id}`);
                if (window['fbq']) {
                    window['fbq']('track', 'Purchase', {
                        content_ids: this.state.bookingCheckoutData.hotelCode,
                        content_name: this.state.bookingCheckoutData.Hotel!.name,
                        content_type: `HaveCoupon=${this.state.bookingCheckoutData.haveCupon}`,
                        contents: this.state.bookingCheckoutData.rooms,
                        currency: this.state.bookingCheckoutData.currencyCode,
                        num_items: JSON.parse(this.state.bookingCheckoutData.rooms!).length
                    });
                }
            }
        ).catch(err => {
            /**
             * TODO: lalukan sesuatu jika error
             */
            console.error(err);
        });
    } 
}



// WEBPACK FOOTER //
// ./src/new-booking/BookingCheckout.tsx